"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { link } from './styles.js';
import { handleButtonUnfocusMouseEvent } from '../Button/utils.js';
import { getFontSize } from '../ContentText/utils.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { ThemeProvider } from 'styled-components';
import { IconExternalLinkA11yIcon } from '../icons/ui_external_link_prop/IconExternalLinkA11yIcon.web.js';
import { spacing } from '../constants/spacing.js';

var _excluded = ["tag", "children", "showExternalIcon", "newTab", "color", "noUnderline", "disableVisited", "onMouseUp", "onMouseOut", "size"];
/**
 * Links are used for navigation, and should describe the purpose and
 * destination of the link in a short and to the point way. If clicking the
 * link will lead to an action such as changed data, use a button instead.
 */

var LinkComponent = function LinkComponent(props, ref) {
  var tag = props.tag,
    children = props.children,
    _props$showExternalIc = props.showExternalIcon,
    showExternalIcon = _props$showExternalIc === undefined ? false : _props$showExternalIc,
    _props$newTab = props.newTab,
    newTab = _props$newTab === undefined ? false : _props$newTab,
    colorProp = props.color,
    _props$noUnderline = props.noUnderline,
    noUnderline = _props$noUnderline === undefined ? false : _props$noUnderline,
    _props$disableVisited = props.disableVisited,
    disableVisited = _props$disableVisited === undefined ? false : _props$disableVisited,
    onMouseUp = props.onMouseUp,
    onMouseOut = props.onMouseOut,
    sizeProp = props.size,
    rest = _objectWithoutProperties(props, _excluded);
  var newTabProps = {
    target: '_blank',
    rel: 'noopener noreferrer'
  };
  var handleMouseUp = React.useMemo(function () {
    return handleButtonUnfocusMouseEvent(onMouseUp);
  }, [onMouseUp]);
  var handleMouseOut = React.useMemo(function () {
    return handleButtonUnfocusMouseEvent(onMouseOut);
  }, [onMouseOut]);
  var theme = useTheme();
  var size = sizeProp || (theme.variant === 'condensed' ? 's' : 'm');
  var linkTheme = theme.link.web;
  var color = colorProp || linkTheme.color;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(link, _extends({
    "data-testid": "elemental-Link"
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ,
    as: tag,
    fontSize: getFontSize(theme.contentText.web.fontSizes, size),
    $color: color,
    $noUnderline: noUnderline,
    $disableVisited: disableVisited
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ,
    onMouseUp: handleMouseUp
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ,
    onMouseOut: handleMouseOut,
    display: showExternalIcon ? 'inline-flex' : 'inline',
    alignItems: showExternalIcon ? 'center' : undefined,
    ref: ref
  }, newTab ? newTabProps : {}, rest), children, showExternalIcon && /*#__PURE__*/React.createElement(IconExternalLinkA11yIcon, {
    color: "currentColor",
    ml: spacing.xxxs
  })));
};
var Link = /*#__PURE__*/React.forwardRef(LinkComponent);

export { Link };
